import { useMemo } from 'react';
import {
  type EstimationGroup,
  type EstimationOption,
  mapSchemeToGroup,
  SETTINGS_GROUP_LABEL,
  SETTINGS_OPTION_VALUE,
} from '@/features/items/components/estimation/useGroupedEstimationOptions';
import { useEstimationSchemesQueryWithPublished } from './useEstimationSchemesQueryWithPublished';

export const useGroupedEstimationOptionsWithPublished = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { data: schemes, isLoading } = useEstimationSchemesQueryWithPublished({ enabled });

  const groupedOptions = useMemo<EstimationGroup[]>(() => {
    if (!schemes) return [];
    const groups = schemes.map(mapSchemeToGroup);
    groups.push({
      label: SETTINGS_GROUP_LABEL,
      options: [
        {
          value: SETTINGS_OPTION_VALUE,
          label: SETTINGS_GROUP_LABEL,
          effortRange: null,
          schemeId: -1,
        },
      ],
    });
    return groups;
  }, [schemes]);

  const flatOptions = useMemo<EstimationOption[]>(
    () => groupedOptions.flatMap((g) => g.options).filter((o) => o.value !== SETTINGS_OPTION_VALUE),
    [groupedOptions],
  );

  return { groupedOptions, flatOptions, isLoading };
};
